import { Component } from "react";
import * as Scrivito from "scrivito";
import isActiveObj from "../utils/isActiveObj";

function HidePageIfInactive(WrappedComponent) {
  const ConnectedWrappedComponent = Scrivito.connect(WrappedComponent);

  return class extends Component {
    active() {
      const { page } = this.props;

      return isActiveObj(page);
    }

    inactive() {
      return !this.active();
    }

    render() {
      if (this.inactive()) {
        return (
          <div className="container py-4">
            {/* i18n translation is needed */}
            <h1>SEITE NICHT GEFUNDEN</h1>
            Leider ist die von Ihnen aufgerufene Seite auf diesem Server nicht
            vorhanden.
            <br />
            <br />
            Fehler: 404 - Seite nicht gefunden
          </div>
        );
      }

      return <ConnectedWrappedComponent {...this.props} />;
    }
  };
}

export default HidePageIfInactive;
